import { Button, LoadingIcon } from "@prosolve/common-components-ui"
import styled from "styled-components"

const StyledButton = styled(Button).attrs({ 
  $colored: true, 
  style: { 
    height: '25px', 
    borderRadius: '20px',
    textAlign: 'center'
  } 
})`
  text-transform: uppercase;

  &:active {
    color: rgba(68, 172, 225, 0.7);
  }
`

export default (props) => {
  const { children, isLoading } = props
  
  const passedProps = { ...props }
  delete passedProps.isLoading

  return (
    <StyledButton {...passedProps}>
      {isLoading && <span style={{ marginRight: '5px', scale: '0.7' }}><LoadingIcon /></span>}
      {children}
    </StyledButton>
  )
}